import { HelpOutline } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { ReactElement, useEffect } from "react";

import { useFreshdeskSSOToken } from "~frontend/providers/LoggedInUserProvider/context";

declare global {
  interface Window {
    fwSettings: any;
    FreshworksWidget: any;
    freshdeskLoadPromise: Promise<any>;
  }
}

const WIDGET_ID = 66000003206;

function loadFreshdesk(ssoToken: string) {
  if (window.freshdeskLoadPromise) {
    // just re-auth
    window.FreshworksWidget("authenticate", {
      token: ssoToken,
    });

    return window.freshdeskLoadPromise;
  }

  window.freshdeskLoadPromise = new Promise(resolve => {
    window.fwSettings = { widget_id: WIDGET_ID };

    window.FreshworksWidget = (...args: any[]) =>
      window.FreshworksWidget.q.push(args);
    window.FreshworksWidget.q = [];
    window.FreshworksWidget("hide", "launcher");
    window.FreshworksWidget("authenticate", {
      token: ssoToken,
    });

    const script = document.createElement("script");
    script.src = `https://widget.freshworks.com/widgets/${WIDGET_ID}.js`;
    script.async = true;
    script.defer = true;

    script.addEventListener("load", resolve);

    document.body.appendChild(script);
  });

  return window.freshdeskLoadPromise;
}

export default function SupportWidget(): ReactElement | null {
  const ssoToken = useFreshdeskSSOToken();

  useEffect(() => {
    if (!ssoToken) {
      return;
    }

    loadFreshdesk(ssoToken).catch(error => {
      console.error("Failed to load Freshdesk widget", error);
    });
  }, [ssoToken]);

  if (!ssoToken) {
    return null;
  }

  const handleHelpIconClick = () => {
    loadFreshdesk(ssoToken)
      .then(() => {
        window.FreshworksWidget("open");
      })
      .catch(error => {
        console.error("Failed to load Freshdesk widget", error);
      });
  };

  return (
    <Box sx={{ width: "238px" }}>
      <Button
        onClick={handleHelpIconClick}
        color="inherit"
        sx={{
          p: 2,
          width: "100%",
          justifyContent: "flex-start",
          textTransform: "none",
        }}
      >
        <HelpOutline sx={{ ml: 1.5 }} />
        <Typography display="inline" sx={{ ml: 1.5, mb: "2px" }}>
          Support
        </Typography>
      </Button>
    </Box>
  );
}
